import { Component, OnInit, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'app-list-right-item',
  templateUrl: './list-right-item.component.html',
  styleUrls: ['./list-right-item.component.scss']
})
export class ListRightItemComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  @Input() data: any;

  constructor() { }

  ngOnInit() {
    // remove this after implementation is done
    console.log('listRightItem component initialized with component data', this.data);
  }
}
